/**
 * Client-side types for the AMC Listed Vendors ops screen.
 * Mirrors the kodo-backend GraphQL contract in payment.graphql:
 *   input  BulkImportHiddenListedVendorRow
 *   type   BulkImportHiddenListedVendorResultRow
 *   type   BulkImportHiddenListedVendorsForKodoPayOutput
 */

// Matches input BulkImportHiddenListedVendorRow { vendorName, accountNumber, ifsc, accountHolderName, emailId?, mobileNo?, isVirtualAccount? }
export interface BulkImportHiddenListedVendorRow {
  vendorName: string;
  accountNumber: string;
  ifsc: string;
  accountHolderName: string;
  emailId?: string;
  mobileNo?: string;
  // Virtual account (e.g. MFU escrow): payouts never pays it via IMPS.
  isVirtualAccount: boolean;
}

// A parsed row plus a local key and any client-side validation error, used only for the preview table.
export interface ParsedVendorRow extends BulkImportHiddenListedVendorRow {
  rowKey: string;
  lineNo: number;
  validationError?: string;
}

// Matches enum BulkImportHiddenVendorRowStatus
export enum BulkImportHiddenVendorRowStatus {
  CREATED = "CREATED",
  SKIPPED_EXISTING = "SKIPPED_EXISTING",
  FAILED = "FAILED",
}

// Matches type BulkImportHiddenListedVendorResultRow
export interface BulkImportHiddenListedVendorResultRow {
  vendorName: string;
  accountNumber: string;
  ifsc: string;
  status: BulkImportHiddenVendorRowStatus;
  error?: string | null;
}

// Matches type BulkImportHiddenListedVendorsForKodoPayOutput
export interface BulkImportHiddenListedVendorsForKodoPayOutput {
  totalRows: number;
  created: number;
  skipped: number;
  failed: number;
  results: BulkImportHiddenListedVendorResultRow[];
}

// Matches type AmcCollectionAccount (query pvtGetAmcCollectionAccountsForKodoPay)
export interface AmcCollectionAccountRow {
  vendorId: string;
  vendorName: string;
  accountNumber: string;
  ifsc: string;
  accountHolderName?: string | null;
  isHiddenFromUser: boolean;
  isVirtualAccount: boolean;
  createdAt: string;
}
